import environmentSettings from "../constants/environmentSettings";

const CONFIG = {
  GOOGLE_API_KEY: environmentSettings.googleApiKey,
  FILE_DOWNLOAD_ACCOUNT_ENDPOINT: environmentSettings.apiManagement + "/aps/api/FileDownload/Account/"
};

export default CONFIG;
